export enum FecThirdPartySortKey {
  AccountNo = 'accountNo',
  Type = 'type',
}
